const cgpQuestionnaire = {
  city_id: null,
  title: null,
  summary: null
};

const top20techQuestionnaire = {
  city_id: null,
  industry: null,
  job_title: null
};

export default {
  questionnaireFormLoading: false,
  questionnaireFormDataCgp: cgpQuestionnaire,
  questionnaireFormErrors: {...cgpQuestionnaire, ...top20techQuestionnaire},

  questionnaireFormDataTop20tech: top20techQuestionnaire
};
